import { gql } from "@apollo/client";

export const ADD_WORKING_HOURS = gql`
  mutation($businessId: ID!, $businessHour: [UpdateWorkingHourInput!]!) {
    addWorkingHours(businessId: $businessId, input: $businessHour) {
      id
    }
  }
`;

export const ADD_WORKING_HOUR = gql`
  mutation AddWorkingHour($input: WorkingHourInput!, $timeZoneId: ID!) {
    addWorkingHour(input: $input, timeZoneId: $timeZoneId) {
      id 
      groupId
      day
      onJob
      startTime
      endTime
      parentId
    }
  }
`;

export const UPDATE_WORKING_HOUR = gql`
  mutation UpdateWorkingHour($input: WorkingHourInput!, $timeZoneId:ID!) {
    updateWorkingHour(input: $input, timeZoneId: $timeZoneId) {
      id 
      groupId
      day
      onJob
      startTime
      endTime
      parentId, 
    }
  }
`;


export const UPDATE_WORKING_HOUR_WITH_INPUT = gql`
  mutation UpdateWorkingHour($hourId: ID!, $hourInput: WorkingHourInput!) {
    updateWorkingHours(hourId: $hourId, input: $hourInput) {
      id
      day
      onJob
      startTime
      endTime
    }
  }
`;

export const DELETE_WORKING_HOUR = gql`
  mutation deleteWorkingHour($workingHourId: ID!) {
    deleteWorkingHour(workingHourId: $workingHourId) {
      success
      message
    }
  }
`;




export const UPDATE_WORKING_HOUR_GROUP = gql`
  mutation UpdateWorkingHourGroup(
    $input: WorkingHourGroupInput!
    $groupId: Int! 
  ) {
    updateWorkingHourGroup(input: $input, groupId: $groupId) {
      id
      title
      def
      timeZone {
              id
              timezone
              }
      workingHours {
      id 
      groupId
      day
      onJob
      startTime
      endTime
      parentId
    }
    }
      
  }
`;
export const ADD_WORKING_HOUR_GROUP = gql`
  mutation AddWorkingHourGroup($input: WorkingHourGroupInput!) {
    addWorkingHourGroup(input: $input) {
      workingHourGroup {
        id 
        def
        title
        custom
        isForBusiness 
        timeZone {
        id
        timezone}
      }
      workingHours {
       id 
        groupId
        day
        onJob
        startTime
        endTime
        parentId
      }
    }
  }
`;

export const ADD_WORKING_HOUR_OVERRIDE_GROUP = gql`
  mutation ($input: newWorkingHourOverrideGroupInput!) {
    addWorkingHourOverrideGroup(input: $input) {
      id 
      groupId: id
    }
  }
`;
export const ADD_WORKING_HOUR_OVERRIDE = gql`
  mutation AddWorkingHourOverride($overrides: [OverrideInput!]!) {
    addWorkingHourOverride(input: { override: $overrides }) {
      id
      staffId: staffId
      groupId
      startTime
      endTime
    }
  }
`;
export const UPDATE_WORKING_HOUR_OVERRIDE = gql`
  mutation ($endTime: String, $startTime: String, $id: ID!) {
    updateWorkingHourOverride(startTime: $startTime, endTime: $endTime, id: $id) {
      id
      groupId
      startTime
      endTime
    }
  }
`;
export const DELETE_WORKING_HOUR_GROUP = gql`
  mutation deleteWorkingHourGroup($groupId: ID!, $newDefault: ID!) {
    deleteWorkingHourGroup(groupId: $groupId, newDefault: $newDefault)
  }
`;

export const DELETE_WORKING_HOUR_OVERRIDE_GROUP = gql`
  mutation deleteOverrides($id: ID!) {
    deleteWorkingHourOverrideGroup(id: $id)
  }
`;

export const UPDATE_WORKING_HOUR_OVERRIDE_GROUP = gql`
    mutation UpdateWorkingHourOverrideGroup($input: updateWorkingHourOverrideGroupInput!) {
        updateWorkingHourOverrideGroup(input: $input) {
            id
            title
            startDate
            endDate
        }
    }
`;